var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPayrateBonus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#1976d2",
    width: "800px",
    height: "800px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76,108A36,36,0,1,1,112,72,36.04,36.04,0,0,1,76,108Zm0-64A28,28,0,1,0,104,72,28.032,28.032,0,0,0,76,44ZM180,148a36,36,0,1,1-36,36A36.04,36.04,0,0,1,180,148Zm0,64a28,28,0,1,0-28-28A28.032,28.032,0,0,0,180,212ZM210.828,45.172a4,4,0,0,1,0,5.656l-160,160a4,4,0,0,1-5.656-5.656l160-160A4,4,0,0,1,210.828,45.172Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayrateBonus);
export default __webpack_public_path__ + "static/media/payrate_bonus.27813d425126fde4b9510632bb442dd2.svg";
export { ForwardRef as ReactComponent };